import React from 'react';
import Card from "@scentregroup/ui/components/card";
import Paragraph from "@scentregroup/ui/components/paragraph";
import Heading from "@scentregroup/ui/components/heading";
import CallToAction from "@scentregroup/ui/components/call-to-action";
import ExternalLink from '../external-link';
import analyticsUtils from '../../helpers/analytics-utils';
import { createProductClickEvent } from '../../helpers/analytics-utils/productClick';
import { CloudinaryImage, IMAGE_SIZES_HALF_HALF } from '../../hub-components/cloudinary-image';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ComparisonItem = _ref => {
  var _heroImageSet$master;
  let {
    productName,
    dotPoints,
    utilityBox,
    callToAction,
    heroImageSet
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: style.comparisonItem,
    "data-id": "comparison-item_index_ComparisonItem_div",
    children: /*#__PURE__*/_jsxs(Card, {
      heading: productName,
      className: style.card,
      headingProps: {
        type: 'medium'
      },
      "data-id": "comparison-item_index_ComparisonItem_div_Card",
      children: [(heroImageSet === null || heroImageSet === void 0 || (_heroImageSet$master = heroImageSet.master) === null || _heroImageSet$master === void 0 ? void 0 : _heroImageSet$master.url) && /*#__PURE__*/_jsx(CloudinaryImage, {
        className: style.image,
        imageSetOrImage: {
          url: heroImageSet.master.url,
          type: 'WIDE',
          alt: heroImageSet.description
        },
        resizeMode: "pad",
        ratio: "4/3",
        sizes: IMAGE_SIZES_HALF_HALF,
        "data-id": "comparison-item_index_ComparisonItem_CloudinaryImage"
      }), /*#__PURE__*/_jsxs("div", {
        className: style.childrenWrapper,
        "data-id": "comparison-item_index_ComparisonItem_Card_div",
        children: [/*#__PURE__*/_jsx("div", {
          className: style.dotPoints,
          "data-id": "comparison-item_index_ComparisonItem_div_div_4",
          children: dotPoints.map(point => /*#__PURE__*/_jsx(Paragraph, {
            "data-id": "comparison-item_index_ComparisonItem_Paragraph",
            children: point
          }, point))
        }), /*#__PURE__*/_jsx(CallToAction, {
          rel: 'noopener',
          target: '_self',
          element: ExternalLink,
          url: callToAction.url,
          className: style.callToAction,
          onClick: productName ? () => createProductClickEvent(productName, analyticsUtils.categories.COMPARISON_MODULE_CTA, callToAction.category) : undefined,
          "data-id": "comparison-item_index_ComparisonItem_div_CallToAction",
          children: callToAction.category
        }), utilityBox && utilityBox.items.length > 0 && /*#__PURE__*/_jsxs("div", {
          className: style.utilityBox,
          "data-id": "comparison-item_index_ComparisonItem_div",
          children: [/*#__PURE__*/_jsx(Heading, {
            type: "small",
            "data-id": "comparison-item_index_ComparisonItem_div_Heading",
            children: utilityBox.heading
          }), utilityBox.items.map(item => /*#__PURE__*/_createElement(ExternalLink, {
            rel: 'noopener',
            target: '_self',
            url: item.url,
            key: item.title,
            eventCategory: productName,
            eventLabel: item.title,
            eventAction: analyticsUtils.categories.COMPARISON_MODULE_CTA,
            "data-id": "comparison-item_index_ComparisonItem_ExternalLink"
          }, /*#__PURE__*/_jsx(Paragraph, {
            className: style.utilityLinkText,
            "data-id": "comparison-item_index_ComparisonItem_ExternalLink_Paragraph",
            children: item.title
          })))]
        })]
      })]
    })
  });
};
export default ComparisonItem;